export default __webpack_public_path__ + "static/media/vouchers.55544b3b.png";